import { toSi } from '@src/core/extensions';
import { MeasurementType } from '@src/core/features/settings/entities';

import { IRouteForm, RouteWaypointEntity, RouteWaypointType } from '../entities';
import { MissionWaypoint } from '../redux/types';

const altitudeFromForm = (w: RouteWaypointEntity, form: IRouteForm): string | number => {
  if (w.type === RouteWaypointType.TAKE_OFF) return form.takeOffAltitude;
  if (w.type === RouteWaypointType.DESTINATION) return form.destinationAltitude;
  return form.waypoints.find((fw) => fw.uuid === w.uuid)?.altitude ?? w.altitude;
};

// Form values are held in the user's display unit. The wire is always SI, so convert
// every dimensional field display -> SI here, at the single point the waypoint payload
// is assembled (UNITS Standard R2). lat/lon are non-dimensional and pass through.
export const toMissionWaypoints = (
  wps: RouteWaypointEntity[],
  form: IRouteForm,
  isAmsl: boolean,
): MissionWaypoint[] =>
  wps.map((w) => ({
    orderId: w.orderId,
    altitude: toSi(altitudeFromForm(w, form), MeasurementType.DISTANCE),
    latitude: w.latitude,
    longitude: w.longitude,
    speed: String(toSi(form.speed, MeasurementType.SPEED)),
    deliveryAltitude: String(toSi(form.deliveryAltitude, MeasurementType.DISTANCE)),
    ...(isAmsl && { winchAltitude: String(toSi(form.winchAltitude, MeasurementType.DISTANCE)) }),
  }));
